import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IBaseConfig } from '../shared/models/base-config';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import  * as  packageJson  from '../../../package.json';
import { UserCache } from './user-cache';
@Injectable({
  providedIn: 'root'
})
export class BaseConfig {

  // 有增減欄位需修改定義檔IBaseConfig
  private static config: IBaseConfig;
  static load = new Observable<IBaseConfig>();
  constructor(private http: HttpClient) {
  }

  static setConfig(data) {
    this.config = data;
    if(!this.config.webApi.hisBaseUrl.endsWith('/'))
    {
      this.config.webApi.hisBaseUrl+='/'
    }
    if(!this.config.webApi.visionAuthUrl.endsWith('/'))
    {
      this.config.webApi.visionAuthUrl+='/'
    }
    var debugFlag = localStorage.getItem('DebugMode')
    if(debugFlag==null){
      localStorage.setItem('DebugMode','');
    }
    if(debugFlag=='F')
    {
      this.config.env.isDebug=false;
    }
  }
  static getConfig():IBaseConfig {
    return this.config;
  }
  static isSuperDebug(){
    var isSuper = UserCache.getLoginUser().IsSuper;
    return isSuper || false;
  }
  static isOfflineMode(){
    return this.config.env?.isOffline??false;
  }
  static isDebug(){
    // 手動開啟偵錯模式
    var debugFlag = localStorage.getItem('DebugMode')
    var manualDebugMode = debugFlag=='T';
    // 強制關閉偵錯模式
    var isForceDisableDebugMode = debugFlag=='F'
    //超級使用者
    var isAdmin = UserCache.getLoginUser().IsAdmin;

    //偵錯環境(dev/demo)
    var isDebugEnv = BaseConfig.getConfig().env?.isDebug;

    // 強制關閉偵錯模式 (可在偵錯環境下模擬非偵錯用)
    if(isForceDisableDebugMode){
      return false;
    }
    return isDebugEnv || manualDebugMode || isAdmin
  }

  // 依據environment讀取設定檔base-config.json
  async loadConfig() {
    let jsonFile = 'assets/configs/base-config.json';
    if (environment.envName) {
      jsonFile = 'assets/configs/base-config.' + environment.envName +'.json';
    }
    BaseConfig.load = this.http.get<IBaseConfig>(jsonFile+'?t='+ new Date().getTime());

    try {
      const data = await BaseConfig.load.toPromise();
      data.version = packageJson.version;
      data.latestVersion = data.version;
      data.ui.rocDate = true;

      try{
        var versionJs = await this.http.get<{version:string}>('assets/version.json?t='+Date.now()).toPromise()
        data.latestVersion =versionJs.version;
      }catch(ex){
        //抓不到 解失敗 等等 都不處理 避免讓使用者緊張
      }

      BaseConfig.setConfig(data);
    } catch (err) {
      alert('Could not load config file.');
    }

  }
}
export function initializeBaseConfig(baseConfig: BaseConfig) {
  return async() => await baseConfig.loadConfig();
}

export var FunctionEnable = {
  get UserLineNotifyQRCode(){ return environment['envName']!= 'prodtw'},
  get EnableTeleMed(){ return environment['envName']!= 'prodtw'},
  /** 前端快取強化 */
  get EnableAutoSpeedTest(){ return false},
  //get EnableClientAdvCache(){ return environment['envName']!= 'prodtw'},
  get EnableClientAdvCache() { return true },
}

